import {
  CanActivate,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Injectable } from "@angular/core";
import {
  SsoAccountFacade,
  SsoAccountCheckoutState,
  IdentityVerificationAction,
  SessionStorageKey,
  SessionStorageState,
} from "common";

@Injectable({
  providedIn: "root",
})
export class CheckoutStateGuard implements CanActivate {
  constructor(
    private router: Router,
    private ssoAccountFacade: SsoAccountFacade
  ) { }

  canActivate(): Observable<boolean> | boolean {
    if (SessionStorageState.get(SessionStorageKey.AccountSetupViewed)) {
      return true;
    }

    return this.ssoAccountFacade
      .getSsoAccountCheckoutState$()
      .pipe(take(1), map((state: SsoAccountCheckoutState) => this.validate(state)));
  }

  private validate(
    state: SsoAccountCheckoutState,
  ): boolean {
    if (state?.identityVerificationAction === IdentityVerificationAction.Skip) {
      return true;
    }

    this.router.navigate([`account/setup`]);
    return false;
  }
}
